import React from 'react';
import './ProducerPlayer.scss';


interface AudioContainerProps {
  isLive?: boolean;
  children?: React.ReactNode;
}

export const InitialsContainer = (props: AudioContainerProps) =>  {

  const {children} = props;

  return (
    <div className="audio-container">
    <div className="participant-circle"></div>
    <div className={"participant-initials " + (props.isLive ? "participant-initials-large" : "")}>
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 500 75"
      preserveAspectRatio="xMinYMid meet"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <text
        x="50%"
        y="80%"
        dominantBaseline="middle"
        textAnchor="middle"
        fontSize="250"
        fontFamily='Proxima Nova'
        fontWeight={'bold'}
        fill="white"
      >
        {children}
      </text>
    </svg>
    </div>
    </div>


  )
}